export class Configuracao {
  nome: string;
  pastaImagens: string;
  template: string;
  style: string;
  esquemaDeCores?: any;
}
